import type { NextPage, GetStaticProps } from 'next'
import { HomePage } from '~pages/home-page/components/home-page'
import { getCategoriesData } from '~shared/api/categories/getCategories'
import { getPopularPrograms } from '~shared/api/programs-popular/getPopularPrograms'
import { getFooterData } from '~shared/api/footer/getFooterData'
import { getDiplomasData } from '~shared/api/diplomas/getDiplomasData'
import { getJournalsData } from '~shared/api/getJournalsData/getJournalsData'
import { getJournalsFacultiesData } from '~shared/api/faculties/getJournalsFacultiesData'


type FunctionPropTypes<T> = T extends (...args: any[]) => any
  ? Parameters<T>[0]
  : never
  
const NextHomePage: NextPage<FunctionPropTypes<typeof HomePage>> = ({
  diplomas,
  // whyUs,
  // questions,
  categories,
  // videos,
  journals,
  tags,
  // images,
  footer,
  popularPrograms,
  // reviews
}: FunctionPropTypes<typeof HomePage>) => {
  return (
    <HomePage
      // whyUs={whyUs}
      diplomas={diplomas}
      // questions={questions}
      categories={categories}
      // videos={videos}
      journals={journals}
      tags={tags}
      // images={images}
      footer={footer}
      popularPrograms={popularPrograms}
      // reviews={reviews}
    />
  )
}

export const getStaticProps: GetStaticProps = async context => {
  try {
    const [
      diplomas,
      // whyUs,
      // questions,
      // videos,
      journals,
      categories,
      tags,
      // images,
      footer,
      popularPrograms,
      // reviews
    ] = await Promise.allSettled([

      getDiplomasData({ context }),
      // Shared.getWhyUsData({ context }),
      // Shared.getFAQData({ context }),
      // Shared.getVideoData({ context }),
      getJournalsData({ context, amount: 4 }),
      getCategoriesData({ context }),
      getJournalsFacultiesData({ context }),
      // Shared.getProgramImagesData({ context }),
      getFooterData({ context }),
      getPopularPrograms({ context }),
      // getReviews({ context })
    ])

    const props = {
      diplomas: diplomas || null,
      // whyUs: whyUs || null,
      // questions: questions || null,
      // videos: videos || null,
      journals: journals || null,
      categories: categories || null,
      tags: tags || null,
      // images: images || null,
      footer: footer || null,
      popularPrograms: popularPrograms || null,
      // reviews: reviews || null
    }

    return {
      props
    }
  } catch (err) {
    console.error(err)
  }

  return {
    props: {}
  }
}

export default NextHomePage
